import _defineProperty from "/home/cabox/workspace/outward/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/cabox/workspace/outward/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["closeLabel", "closeVariant", "closeButton", "onHide", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { useContext } from 'react';
import useEventCallback from '@restart/hooks/useEventCallback';
import CloseButton from './CloseButton';
import ModalContext from './ModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
var AbstractModalHeader = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var closeLabel = _ref.closeLabel,
      closeVariant = _ref.closeVariant,
      closeButton = _ref.closeButton,
      onHide = _ref.onHide,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var context = useContext(ModalContext);
  var handleClick = useEventCallback(function () {
    context == null ? void 0 : context.onHide();
    onHide == null ? void 0 : onHide();
  });
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: [children, closeButton && /*#__PURE__*/_jsx(CloseButton, {
      "aria-label": closeLabel,
      variant: closeVariant,
      onClick: handleClick
    })]
  }));
});
AbstractModalHeader.defaultProps = defaultProps;
export default AbstractModalHeader;